// extracted by mini-css-extract-plugin
module.exports = {"item":"DyAGe","name":"TJAI4","price":"TQVqO","radio":"v0dwX","option":"d5yPB","title":"sQDHi"};